import React from 'react';
import styled from 'styled-components';
import UserSection from './UserSection';
import ListingSection from './ListingSection';
import LockboxSection from './LockboxSection';
import ShowingSection from './ShowingSection';
import SubscriptionSection from './SubscriptionSection';
import { MLSUserPageContextProvider } from './MLSUserPageContext';
import LockboxReturnBanner from './LockboxReturnBanner';
import NotesSection from './NotesSection';
import CoopSection from './CoopSection';

const MLSUserPage: React.FC = () => {
  const lockboxSection = React.useRef(null);

  return (
    <MLSUserPageContextProvider>
      <Container>
        <LockboxReturnBanner lockboxSection={lockboxSection.current} />
        <UserSection />
        <SubscriptionSection />
        <LockboxSection sectionRef={lockboxSection} />
        <ListingSection />
        <ShowingSection />
        <CoopSection />
        <NotesSection />
      </Container>
    </MLSUserPageContextProvider>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  padding: 18px;
`;

export default MLSUserPage;
